import { OPTIONS_TYPE } from '@/enums';

const name = {
  label: '定向包名称',
  type: 'input',
  value: '',
  rules: {
    required: true,
    message: '请输入定向包名称',
    trigger: ['change'],
  },
  props: {
    placeholder: '请输入定向包名称',
  },
};

const geo_location = {
  value: {},
  children: {
    /** 地域 */
    geo_type: {
      label: '地域',
      type: 'radio-group',
      options: [
        { label: '不限', value: 'INFINITE' },
        { label: '按地域', value: 'LOCATION' },
      ],
      isButton: true,
      value: 'INFINITE',
    },
    /** 地域类型 */
    location_type: {
      label: '地域类型',
      type: 'radio-group',
      options: [
        { label: '常住地', value: 'RESIDENCE' },
        { label: '近期到访', value: 'CURRENT' },
      ],
      value: 'RESIDENCE',
      isButton: true,
      hidden: true,
    },
    /** 常住地 */
    residence_geo_locations: {
      label: ' ',
      type: 'tree-shuttle',
      options: [],
      value: [],
      props: {
        nodeKey: 'value',
      },
      name: '常住地',
      hidden: true,
      rules: {
        required: true,
        trigger: ['blur'],
        validator: (rule, value, callback) => {
          if (value.length) {
            callback();
          } else {
            callback(new Error('请选择地域'));
          }
        },
      },
    },
    /** 近期到访 */
    current_geo_locations: {
      label: ' ',
      type: 'tree-shuttle',
      options: [],
      value: [],
      props: {
        nodeKey: 'value',
      },
      name: '近期到访',
      hidden: true,
      rules: {
        required: true,
        trigger: ['blur'],
        validator: (rule, value, callback) => {
          if (value.length) {
            callback();
          } else {
            callback(new Error('请选择地域'));
          }
        },
      },
    },
  },
};

const gender = {
  label: '性别',
  type: 'radio-group',
  options: [],
  value: OPTIONS_TYPE.UNLIMITED,
  isButton: true,
};

const audience = {
  value: {},
  children: {
    /** 人群类型 */
    audience_types: {
      label: '自定义人群',
      type: 'checkbox-group',
      value: ['INFINITE'],
      options: [
        { label: '不限', value: 'INFINITE' },
        { label: '包含人群', value: 'INCLUDE' },
        { label: '排除人群', value: 'EXCLUDE' },
      ],
      isButton: true,
    },
    /** 包含人群 */
    include_audiences: {
      label: ' ',
      type: 'tree-shuttle',
      options: [],
      value: [],
      props: {
        nodeKey: 'value',
      },
      name: '包含人群',
      hidden: true,
      rules: {
        required: true,
        trigger: ['blur'],
        validator: (rule, value, callback) => {
          if (value.length) {
            callback();
          } else {
            callback(new Error('请选择包含人群'));
          }
        },
      },
    },
    /** 排除人群 */
    exclude_audiences: {
      label: ' ',
      type: 'tree-shuttle',
      options: [],
      value: [],
      props: {
        nodeKey: 'value',
      },
      name: '排除人群',
      hidden: true,
      rules: {
        required: true,
        trigger: ['blur'],
        validator: (rule, value, callback) => {
          if (value.length) {
            callback();
          } else {
            callback(new Error('请选择排除人群'));
          }
        },
      },
    },
  },
};

export {
  name, // 定向包名称
  geo_location, // 地域
  gender, // 性别
  audience, // 自定义人群
};
